import { mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('lightbox', ['items', 'index']),
  },
  methods: {
    ...mapMutations({
      setLightboxItems: 'lightbox/setItems',
      setLightboxIndex: 'lightbox/setIndex',
    }),
  },
};
